import React from 'react';
import debounce from './debounce';

function getViewportDimensions() {
  return {
    windowWidth: Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    ),
    windowHeight: Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    ),
  };
}

export class FitToWindow extends React.Component {
  static defaultProps = {
    fit: true,
    fitWidth: false,
    centerVertical: false,
    centerHorizontal: false,
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = this.getUpdatedState();
    this.handleWindowResize = debounce(this.handleWindowResize, 100).bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowResize);

    this.oldViewport = getViewportDimensions();
    this.interval = setInterval(this.checkViewportDimensions, 100);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
    clearInterval(this.interval);
  }

  componentDidUpdate(prevProps) {
    const props = this.props;
    if (
      prevProps.fit !== props.fit ||
      prevProps.fitWidth !== props.fitWidth ||
      prevProps.centerVertical !== props.centerVertical ||
      prevProps.centerHorizontal !== props.centerHorizontal
    ) {
      this.setState(this.getUpdatedState());
    }
  }

  render() {
    let style = {};

    if (this.props.fit) {
      let { scale, top, left } = this.state;
      const { width, height } = this.props;

      style = {
        transform: `translate(${left}px, ${top}px) scale(${scale})`,
        transformOrigin: '0 0',
        width: `${width}px`,
        height: `${height}px`,
      };
    }

    return (
      <div ref="wrapper" className={this.props.className} style={style}>
        {this.props.children}
      </div>
    );
  }

  checkViewportDimensions = () => {
    const viewport = getViewportDimensions();
    if (
      viewport.windowWidth !== this.oldViewport.windowWidth ||
      viewport.windowHeight !== this.oldViewport.windowHeight
    ) {
      this.handleWindowResize();
    }
    this.oldViewport = viewport;
  };

  getUpdatedState = () => {
    const state = getViewportDimensions();
    let { windowWidth, windowHeight } = state;
    const { width, height } = this.props;

    if (this.props.maxWidth) {
      windowWidth = Math.min(windowWidth, this.props.maxWidth);
    }

    if (this.props.minWidth) {
      windowWidth = Math.max(windowWidth, this.props.minWidth);
    }

    if (this.props.maxHeight) {
      windowHeight = Math.min(windowHeight, this.props.maxHeight);
    }

    if (this.props.minHeight) {
      windowHeight = Math.max(windowHeight, this.props.minHeight);
    }

    state.scale = 1;

    if (width !== windowWidth && height !== windowHeight) {
      let scaleX = windowWidth / width,
        scaleY = windowHeight / height;

      if (this.props.fitWidth) {
        state.scale = scaleX;
      } else {
        state.scale =
          windowWidth / windowHeight > width / height ? scaleY : scaleX;
      }
    }

    const { centerVertical, centerHorizontal } = this.props;
    const s = state.scale;
    state.top = centerVertical
      ? Math.round((windowHeight - s * height) / 2)
      : 0;
    state.left = centerHorizontal
      ? Math.round((windowWidth - s * width) / 2)
      : 0;

    this.props.onChange(state);

    return state;
  };

  handleWindowResize() {
    this.setState(this.getUpdatedState());
  }
}
